const I18n = {
    SettingPopupTitle: 'Settings',
};

export default I18n;
